export const HEADER_TYPE_DEFAULT = "header_type_default";
export const HOSPITAL_HEADER_TYPE = "hospital_header_type";
export const HOSPITAL_DETAIL_HEADER_TYPE = "hospital_detail_header_type";
export const INFORM_HEADER_TYPE = "inform_header_type";
export const MAIN_HEADER_TYPE = "hospital_header_type";
export const ERROR_HEADER_TYPE = "error_header_type";
export const USER_HEADER_TYPE = "user_header_type";
export const ADMIN_HEADER_TYPE = "admin_header_type";
export const DEFAULT_MAP_HEADER_TYPE = "map_default_header_type";
